var _g, _path, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaseIcon7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_n_4140_528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0162 3.26605C24.0231 4.76705 23.4439 6.56594 23.4439 8.50043C23.444 10.8297 24.283 12.9623 25.6744 14.6147L18.3375 21.9526L13.6236 17.2387L11.2662 19.5961L18.3375 26.6664L28.2466 16.7563C29.6322 17.5462 31.2348 18.0004 32.9439 18.0004C34.1099 18.0004 35.2263 17.7882 36.2584 17.4037L35.5845 19.4868C35.4766 19.8202 35.4767 20.1796 35.5845 20.5131L36.4937 23.3217C37.2499 25.6577 36.1988 28.1977 34.0123 29.3149L31.3834 30.6577C31.0712 30.8173 30.8174 31.071 30.6578 31.3832L29.315 34.0121C28.1978 36.1986 25.6578 37.2498 23.3218 36.4936L20.5132 35.5844C20.1797 35.4766 19.8204 35.4765 19.4869 35.5844L16.6783 36.4936C14.3425 37.2496 11.8032 36.1985 10.6861 34.0121L9.34332 31.3832C9.18383 31.0711 8.92987 30.8173 8.61774 30.6577L5.98883 29.3149C3.80233 28.1977 2.75023 25.6577 3.50641 23.3217L4.41559 20.5131C4.52349 20.1796 4.52357 19.8203 4.41559 19.4868L3.50641 16.6782C2.75049 14.3423 3.80246 11.803 5.98883 10.686L8.61774 9.3432C8.92986 9.18367 9.18379 8.92974 9.34332 8.61762L10.6861 5.98871C11.8031 3.80234 14.3425 2.75037 16.6783 3.50629L19.4869 4.41547C19.8204 4.52345 20.1797 4.52335 20.5132 4.41547L23.3218 3.50629C23.8823 3.32485 24.4547 3.24861 25.0162 3.26605Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4140_528",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 34,
    height: 34
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0162 3.26576C24.023 4.76684 23.4429 6.56545 23.4429 8.50013C23.4429 10.8295 24.2829 12.9619 25.6744 14.6144L18.3375 21.9533L13.6236 17.2384L11.2662 19.5958L18.3375 26.6671L28.2466 16.757C29.6321 17.5467 31.2341 18.0001 32.9429 18.0001C34.1092 18.0001 35.2261 17.7889 36.2584 17.4044L35.5845 19.4874C35.4767 19.821 35.4766 20.1803 35.5845 20.5138L36.4937 23.3224C37.2497 25.6583 36.1977 28.1975 34.0113 29.3146L31.3834 30.6574C31.0711 30.817 30.8165 31.0707 30.6568 31.3829L29.314 34.0119C28.1969 36.1983 25.6578 37.2503 23.3218 36.4943L20.5132 35.5851C20.1797 35.4771 19.8205 35.4772 19.4869 35.5851L16.6783 36.4943C14.3424 37.2504 11.8032 36.1984 10.6861 34.0119L9.34332 31.3829C9.18375 31.0707 8.92904 30.817 8.61676 30.6574L5.98883 29.3146C3.80242 28.1975 2.7504 25.6583 3.50641 23.3224L4.41559 20.5138C4.52356 20.1803 4.52346 19.821 4.41559 19.4874L3.50641 16.6788C2.75023 14.3429 3.80233 11.8037 5.98883 10.6867L8.61676 9.34291C8.92909 9.18334 9.18376 8.92965 9.34332 8.61732L10.6861 5.98841C11.8033 3.80218 14.3425 2.75083 16.6783 3.50697L19.4869 4.41615C19.8204 4.52403 20.1797 4.52407 20.5132 4.41615L23.3218 3.50697C23.8824 3.32551 24.4546 3.24827 25.0162 3.26576Z",
    fill: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4140_528)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_fn_4140_528)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.7702,
    cy: 33.0703,
    rx: 24.3611,
    ry: 39.1926,
    transform: "rotate(-44.9306 10.7702 33.0703)",
    fill: "url(#paint0_linear_4140_528)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_n_4140_528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5443 14.5232L33.9553 13.5804C34.6878 11.8993 36.0072 10.5609 37.6535 9.82866L38.9195 9.26556C39.6042 8.96108 39.6042 7.96488 38.9195 7.6604L37.7243 7.12876C36.0357 6.37771 34.6927 4.98974 33.9727 3.25157L33.5507 2.23275C33.2566 1.52268 32.276 1.52268 31.9818 2.23275L31.5598 3.25157C30.84 4.98974 29.497 6.37771 27.8083 7.12876L26.613 7.6604C25.9285 7.96488 25.9285 8.96108 26.613 9.26556L27.8791 9.82866C29.5255 10.5609 30.8448 11.8993 31.5773 13.5804L31.9882 14.5232C32.289 15.2134 33.2437 15.2134 33.5443 14.5232Z",
    fill: "url(#paint1_linear_4140_528)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_n_4140_528",
    x: 3.2627,
    y: 3.2627,
    width: 33.4746,
    height: 33.4746,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "1.6000000238418579 1.6000000238418579",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 5142
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "shape",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(255, 255, 255, 0.25)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_noise_4140_528"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shape"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_fn_4140_528",
    x: -34.3477,
    y: -12.0825,
    width: 90.2354,
    height: 90.3057,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.25,
    result: "effect1_foregroundBlur_4140_528"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "1.6000000238418579 1.6000000238418579",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 5142
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "effect1_foregroundBlur_4140_528",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(0, 0, 0, 0.25)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect2_noise_4140_528"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "effect1_foregroundBlur_4140_528"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_n_4140_528",
    x: 26.0996,
    y: 1.7002,
    width: 13.333,
    height: 13.3408,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "2.6666667461395264 2.6666667461395264",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 1050
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "shape",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(0, 0, 0, 0.1)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_noise_4140_528"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shape"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4140_528",
    x1: 41.0486,
    y1: 22.8302,
    x2: 11.5268,
    y2: 43.2919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.276417,
    stopColor: "#081681"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583149,
    stopColor: "#0F9CFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#997BAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4140_528",
    x1: 32.7663,
    y1: 1.7002,
    x2: 32.7663,
    y2: 15.0408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC1503"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7700"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseIcon7);
export default __webpack_public_path__ + "static/media/caseIcon7.304dfb40f125453258baae0a48270651.svg";
export { ForwardRef as ReactComponent };